import { cookieService } from "./cookie-service";
import { queryParamService } from "./query-param-service";

const setupCallApi = (apiurl) => (url, options = {}) =>
  fetch(`${apiurl}${url}`, {
    ...options,
    headers: {
      "content-type": "application/json",
      ...options.headers
    },
    mode: "cors"
  })
  .then(resp => resp.json());

let callApi = null;

const getAffiliateReferralCookies = () => {
  const affiliateReferralPartnerId = cookieService.get("partnerId");
  const affiliateReferralId = cookieService.get("affiliateId");

  const affiliateReferralCustomerIdClickRef
    = queryParamService.get("clickref")
    || cookieService.get("clickref");

  const affiliateReferralCustomerId = affiliateReferralCustomerIdClickRef
    || cookieService.get("customerId");

  if (affiliateReferralCustomerId && affiliateReferralPartnerId) {
    return {
      affiliateReferralPartnerId,
      affiliateReferralCustomerId,
      ...(affiliateReferralId ? { affiliateReferralId } : {})
    }
  }
  return undefined;
};

const getReferrerTokenInput = () => {

  const referrerToken = cookieService.get("referral-token");
  if (!referrerToken) {
    return;
  }
  return { referrerToken };
};

export const apiService = {
  setBaseUrl: (apiurl) => {
    callApi = setupCallApi(apiurl);
  },

  getSignUp: (id, affiliateReferralCustomerId) => {
    const query = [
      `id=${id ?? ""}`,
      "partnerId=switchcraft",
      affiliateReferralCustomerId &&
        `affiliateReferralCustomerId=${
          affiliateReferralCustomerId
        }`
    ]
      .filter(Boolean)
      .join("&");
    return callApi(`/sign-up?${query}`)
  },

  getAddress: (id) => callApi(`/address/${id}`),

  getAddresses: (postcode) => callApi(`/addresses?postcode=${postcode}`),

  saveAddressAndEmailPage: async (inputs) => {
    const affiliateReferral = getAffiliateReferralCookies();
    const response = await callApi(
      "/save-address-email",
      {
        method: "POST",
        body: JSON.stringify({
          ...inputs,
          ...affiliateReferral,
          ...getReferrerTokenInput()
        })
      }
    );
    return response;
  },

  validatePostcode: (postcode) => callApi(`/validate-postcode?postcode=${postcode}`)

};
